module.exports = __webpack_public_path__ + "img/om-team.d4387068.jpg";